/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

import { createReducer, on } from '@ngrx/store';
import * as UserProfileActions from './user-profile.actions';
import { initialState, IUserProfileState } from './user-profile.state';

export const userProfileFeatureKey = 'userProfile';

export const userProfileReducer = createReducer(
    initialState,
    on(
        UserProfileActions.setUserProfile,
        (state: IUserProfileState, { payload }): IUserProfileState => ({
            ...state,
            profile: {
                ...payload,
            },
        }),
    ),
);
